export default __webpack_public_path__ + "static/media/lemon-wintermelon-tea.6f6a4ec8.png";